import Vue from "vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import NProgress from "nprogress";
import { Notification } from "element-ui";
import { MessageBox } from "element-ui";
import "nprogress/nprogress.css";

//引入nprogress进度组件
NProgress.configure({
  ease: "ease",
  minimum: 0.3,
  showSpinner: false,
});
Vue.prototype.$NProgress = NProgress;
//添加alert弹框
Vue.prototype.$alert = (u) => {
  return Vue.prototype.$toast(
    {
      component: ToastificationContent,
      props: u,
    },
    {
      position: "top-center",
    }
  );
};

//bootstarp错误提示
Vue.prototype.$alertError = (message, title) => {
  Vue.prototype.$alert({
    title: title || "错误",
    icon: "XIcon",
    text: message || "请求错误",
    variant: "danger",
  });
};
//bootstarp成功提示
Vue.prototype.$alertSuccess = (message, title) => {
  Vue.prototype.$alert({
    title: title || "成功",
    icon: "CheckIcon",
    text: message || "请求成功",
    variant: "success",
  });
};
//bootstarp确定框
Vue.prototype.$confirm = (text) => {
  return MessageBox.confirm(text, "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  });
};
//elementui的错误弹框
Vue.prototype.$errorAlert = (message, title) => {
  Notification.error({
    title: title || "请求错误",
    message: message,
    duration: 3000,
  });
};
//elementui的成功弹框
Vue.prototype.$successAlert = (message, title) => {
  Notification.success({
    title: title || "提示",
    message: message,
    duration: 3000,
  });
};
const S4 = () => {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
};
Vue.prototype.$guid = () => {
  return (
    S4() +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    S4() +
    S4()
  );
};
Vue.prototype.$guid2 = () => {
  return S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4();
};
Vue.prototype.$appendParamToUrl = (url, paramName, paramValue) => {
  if (paramValue != "" && paramValue != undefined && paramValue != null) {
    if (url.indexOf("?") === -1) {
      url += "?" + paramName + "=" + encodeURIComponent(paramValue);
    } else {
      url += "&" + paramName + "=" + encodeURIComponent(paramValue);
    }
  }
  return url;
};
Vue.prototype.$setToken = (token) => {
  var token_str = JSON.stringify(token);
  localStorage.setItem("token", token_str);
};
Vue.prototype.$getToken = () => {
  var token = localStorage.getItem("token");
  if (!token) {
    return {};
  }
  return JSON.parse(token);
};
Vue.prototype.$removeToken = (token) => {
	localStorage.removeItem('token');
};
